import nuskin from './namespace.js';
import storage from './storage';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace nsSearchBarAdapter
 */
nuskin.site.PreferencesCookieService = function(){

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {
        getPreferences : function(){
            let preferences = null;
            let preferencesData = getStoredPreferences();

            preferences = new nuskin.site.Preferences(preferencesData);

            return preferences;
        },
        setPreferences : function(preferences){
            writePreferencesToStorage(preferences);
        },
        resetPreferencesCookie : function(){
            writePreferencesToStorage(null);
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getStoredPreferences(){
        let preferences = null;
        if ($.cookie !== undefined){
            let cookieVal = storage(storage.metadata.NUSKIN_SITE);
            if (cookieVal !== null && cookieVal !== undefined) {
                let account = JSON.parse(cookieVal);
                if (account !== null && account !== undefined){
                    preferences = JSON.parse(cookieVal).preferences;
                }
            }
        }
        return preferences;
    }

    function writePreferencesToStorage(preferences){
        if ($.cookie !== undefined) {
            let options = {path: '/'};
            if (preferences !== null  && preferences instanceof nuskin.site.Preferences){
                storage(storage.metadata.NUSKIN_SITE, {preferences: preferences.toJSON()}, options);
            }
            else {
                storage(storage.metadata.NUSKIN_SITE, {preferences: preferences}, options);
            }
        }
    }

    return publicMethods;
}();

export default nuskin.site.PreferencesCookieService;
